import { render, staticRenderFns } from "./tmEmptyView.vue?vue&type=template&id=2178995a&"
import script from "./tmEmptyView.vue?vue&type=script&lang=js&"
export * from "./tmEmptyView.vue?vue&type=script&lang=js&"
import style0 from "./tmEmptyView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports